import * as Yup from "yup";

export const validation = (t) =>
    Yup.object({
        theme: Yup.string()
            .min(2, `${t("registration.minLength")}2`)
            .max(64, `${t("registration.maxLength")}64`)
            .required(t("registration.required")),
        message: Yup.string()
            .min(2, `${t("registration.minLength")}2`)
            .max(65535, `${t("registration.maxLength")}65535`)
            .required(t("registration.required")),
    });
